import { UserRoles } from "../types/users.type";

export const ProtectedRoutesConfig = [
    { prefix: '/classes', allowedRoles: [UserRoles.ADMIN, UserRoles.HEAD_COACH, UserRoles.TRAINER] },
    { prefix: '/periodizations', allowedRoles: [UserRoles.ADMIN, UserRoles.HEAD_COACH] },
    { prefix: '/workouts', allowedRoles: [UserRoles.ADMIN, UserRoles.HEAD_COACH] },
    { prefix: '/warmups', allowedRoles: [UserRoles.ADMIN, UserRoles.HEAD_COACH] },
    { prefix: '/movements', allowedRoles: [UserRoles.ADMIN, UserRoles.HEAD_COACH] },
    { prefix: '/exercises', allowedRoles: [UserRoles.ADMIN] },
    { prefix: '/exercisetypes', allowedRoles: [UserRoles.ADMIN] },
    { prefix: '/equipments', allowedRoles: [UserRoles.ADMIN] },
    { prefix: '/targetareas', allowedRoles: [UserRoles.ADMIN] },
    { prefix: '/trainers', allowedRoles: [UserRoles.ADMIN] },
    { prefix: '/studios', allowedRoles: [UserRoles.ADMIN] }
];